import {Component, Input, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {ParametersService} from '@catmodules/models/parameters/services/parameters.service';
import {isNullOrUndefined} from "util";

/**
 * Provides a form element to edit a feature or project unit parameter.
 *
 * Renders a text input box for parameters without options, and a dropdown
 * menu for parameters with options.
 */
@Component({
  selector: 'cat-input-parameter',
  templateUrl: './input-parameter.component.html',
  styleUrls: ['./input-parameter.component.scss'],
})
export class InputParameterComponent implements OnInit {

  @Input() parameter: any;
  @Input() parentForm: FormGroup;
  @Input() fileList: any[];
  @Input() allowNullValue: boolean = false;

  @Input() showLabel: boolean = true;
  @Input() showDescription: boolean = true;
  @Input() appendTo: string = null;

  parameterOptionValueField = 'value';
  parameterOptionLabel = 'label';

  controls = {
    value: 'value',
  };

  constructor(private parametersService: ParametersService) { }

  ngOnInit() {
  }

  parameterOptions(parameter): any[] {
    const options = this.parametersService.parameterOptions(parameter);
    if (this.allowNullValue && (undefined === options.find((o) => o.value === null))) {
      return [
        {value: null, label: ''},
        ...options
      ];
    } else {
      return options;
    }
  }

  isParameterWithOptions(parameter): boolean {
    return this.parametersService.isParameterWithOptions(parameter);
  }

  hasFileList(): boolean {
    return   !isNullOrUndefined(this.fileList) && this.fileList.length > 0;
  }

  isFileParameter(parameter) {
    return this.parametersService.isFileParameter(parameter);
  }

  label() {
    if (!this.showLabel) {
      return null;
    }

    return this.parameter.label;
  }

  description() {
    if (!this.showDescription) {
      return null;
    }

    return this.parameter.description;
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/parameters/components/input-parameter/input-parameter.component.ts